/* ═══════════════════════════════════════════════════════════════════════════
   ENDRO — Routine Anti-Âge v3 (Liquid) — Logique JS globale
   - Scroll reveal partagé (.endro-reveal → .is-in)
   - (les logiques par section sont ajoutées au fil de la conversion :
      toggle Matin/Soir, accordion FAQ, sticky mobile, etc.)
   ═══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  // ─── Scroll reveal partagé ───────────────────────────────────────────
  function initReveal() {
    var els = document.querySelectorAll('.endro-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.2 });
    els.forEach(function (el) { io.observe(el); });
  }

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  // ─── Smooth-scroll partagé ([data-scroll-target]) ────────────────────
  function initScrollTargets(root) {
    (root || document).querySelectorAll('[data-scroll-target]').forEach(function (btn) {
      if (btn.__bound) return;
      btn.__bound = true;
      btn.addEventListener('click', function () {
        var t = btn.getAttribute('data-scroll-target');
        if (!t || t === 'top') { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
        var el = document.getElementById(t);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  // ─── Hero : galerie + compose + prix + réassurances ──────────────────
  function fmtEuro(n) {
    return n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function fill(tpl, map) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (_, k) {
      return map[k] != null ? map[k] : '';
    });
  }
  function plural(str, n) {
    return n > 1 ? str : str.replace(/produits/g, 'produit');
  }

  function initHero(root) {
    var hero = (root || document).querySelector('[data-endro-hero]');
    if (!hero || hero.__heroBound) return;
    hero.__heroBound = true;

    var discount = (parseFloat(hero.getAttribute('data-discount')) || 0) / 100;

    /* — Galerie — */
    var track = hero.querySelector('[data-gallery-track]');
    var fades = hero.querySelectorAll('[data-gallery-fade]');
    var thumbs = hero.querySelectorAll('[data-gallery-thumb]');
    var dots = hero.querySelectorAll('[data-gallery-dot]');
    var active = 0;
    function setActive(i) {
      active = i;
      fades.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    if (track) {
      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== active) setActive(idx);
      }, { passive: true });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setActive(parseInt(t.getAttribute('data-gallery-thumb'), 10)); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-gallery-dot'), 10);
        if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      });
    });

    /* — Compose + prix + CTA — */
    var rows = Array.prototype.slice.call(hero.querySelectorAll('[data-product]'));
    var total = rows.length;
    var elPrice = hero.querySelector('[data-final-price]');
    var elOld = hero.querySelector('[data-old-price]');
    var elBadge = hero.querySelector('[data-discount-badge]');
    var elNote = hero.querySelector('[data-price-note]');
    var elCta = hero.querySelector('[data-cta]');
    var productUrl = hero.getAttribute('data-product-url');
    var T = {
      ctaFull: hero.getAttribute('data-cta-full'),
      ctaPartial: hero.getAttribute('data-cta-partial'),
      ctaEmpty: hero.getAttribute('data-cta-empty'),
      saveFull: hero.getAttribute('data-save-full'),
      savePartial: hero.getAttribute('data-save-partial'),
      saveEmpty: hero.getAttribute('data-save-empty')
    };
    var dPct = Math.round(discount * 100);

    function recompute() {
      var on = rows.filter(function (r) { return r.classList.contains('is-on'); });
      var count = on.length;
      var subtotal = on.reduce(function (s, r) { return s + (parseFloat(r.getAttribute('data-price')) || 0); }, 0);
      var isFull = count === total && total > 0;
      var finalP = isFull ? subtotal * (1 - discount) : subtotal;
      var savings = isFull ? subtotal - finalP : 0;

      if (elPrice) elPrice.textContent = fmtEuro(finalP);
      if (elOld) { elOld.hidden = !isFull; elOld.textContent = fmtEuro(subtotal); }
      if (elBadge) elBadge.hidden = !isFull;

      if (elNote) {
        elNote.classList.toggle('is-full', isFull);
        if (isFull) elNote.textContent = fill(T.saveFull, { save: fmtEuro(savings) });
        else if (count === 0) elNote.textContent = T.saveEmpty;
        else elNote.textContent = plural(fill(T.savePartial, { n: total - count, d: dPct }), total - count);
      }
      if (elCta) {
        elCta.disabled = count === 0;
        if (isFull) elCta.textContent = fill(T.ctaFull, { price: fmtEuro(finalP) });
        else if (count === 0) elCta.textContent = T.ctaEmpty;
        else elCta.textContent = plural(fill(T.ctaPartial, { n: count, price: fmtEuro(finalP) }), count);
      }
    }

    rows.forEach(function (row) {
      var btn = row.querySelector('[data-toggle]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var on = row.classList.toggle('is-on');
        row.classList.toggle('is-off', !on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
        var minus = btn.querySelector('.ico-minus');
        var plus = btn.querySelector('.ico-plus');
        if (minus) minus.style.display = on ? '' : 'none';
        if (plus) plus.style.display = on ? 'none' : '';
        recompute();
      });
    });
    if (elCta) {
      elCta.addEventListener('click', function () {
        if (!elCta.disabled && productUrl) window.location.href = productUrl;
      });
    }
    recompute();

    /* — Réassurances : slider auto mobile — */
    var rTrack = hero.querySelector('[data-reassure-track]');
    var rDots = hero.querySelectorAll('[data-reassure-dot]');
    if (rTrack && rDots.length) {
      var rIdx = 0;
      var rN = rDots.length;
      function setR(i) {
        rIdx = i;
        rTrack.style.transform = 'translateX(-' + (i * 100) + '%)';
        rDots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      rDots.forEach(function (d, k) { d.addEventListener('click', function () { setR(k); }); });
      setInterval(function () { setR((rIdx + 1) % rN); }, 2800);
    }
  }

  // ─── Hero HV : galerie + compose full-row + tuile verte + count ─────
  function initHeroHv(root) {
    var hero = (root || document).querySelector('[data-endro-hero-hv]');
    if (!hero || hero.__heroHvBound) return;
    hero.__heroHvBound = true;

    /* Decomposition tarifaire : OPT-IN via data-decompose sur la section.
       Sans cet attribut le comportement reste exactement celui d'avant, ce qui
       protege les pages deja mesurees (V4, ancienne variante, V3). */
    var decompose = hero.hasAttribute('data-decompose');

    /* ── Table des packs (miroir de PACKS[] dans HeroProduct.tsx) ─── */
    var SOLO_VARIANTS_HV = {
      'serum-repulpant': 52047734014299,
      'creme-jour':      52016277881179,
      'creme-nuit':      52056385356123,
      'contour-yeux':    52047845097819,
      'serum-liftant':   52047857058139,
    };

    var PACKS_HV = [
      { key: 'creme-jour|serum-repulpant',                                     name: 'Duo Visage Repulpant',          price: 42.56, compareAt: 44.80, discount: 5,  reviews: 280, url: '/products/duo-visage-routine-anti-age-repulpant',            variantId: 52093103931739 },
      { key: 'creme-nuit|serum-liftant',                                        name: 'Duo Visage Liftant',             price: 42.56, compareAt: 44.80, discount: 5,  reviews: 260, url: '/products/duo-collagene',                                    variantId: 52093177889115 },
      { key: 'serum-liftant|serum-repulpant',                                   name: 'Duo Sérums Anti-Âge',            price: 47.31, compareAt: 49.80, discount: 5,  reviews: 346, url: '/products/duo-serums-anti-age',                              variantId: 52097106149723 },
      { key: 'creme-jour|creme-nuit',                                           name: 'Duo Crèmes Anti-Âge',            price: 37.81, compareAt: 39.80, discount: 5,  reviews: 532, url: '/products/duo-creme-anti-age-jour-et-nuit',                  variantId: 52097045102939 },
      { key: 'contour-yeux|creme-jour|serum-repulpant',                         name: 'Routine Anti-Âge Repulpant',     price: 56.72, compareAt: 59.70, discount: 5,  reviews: 931, url: '/products/routine-visage-anti-age',                          variantId: 52096623083867 },
      { key: 'contour-yeux|creme-nuit|serum-liftant',                           name: 'Routine Anti-Âge Liftant',       price: 56.72, compareAt: 59.70, discount: 5,  reviews: 810, url: '/products/routine-visage-anti-age-lifting-et-fermete',       variantId: 52096862323035 },
      { key: 'contour-yeux|creme-jour|creme-nuit|serum-liftant|serum-repulpant',name: 'Routine Complète Jour & Nuit',   price: 94.05, compareAt: 104.50, discount: 10, reviews: 390, url: '/products/routine-visage-anti-age-complete-peaux-matures', variantId: 52097000112475 },
    ];

    /* ── Galeries par pack ─────────────────────────────────────────── */
    var CDN_HV = 'https://cdn.shopify.com/s/files/1/0262/5313/1854/files/';
    var GALLERIES_HV = {
      'creme-jour|serum-repulpant': [
        CDN_HV + 'duo-visage-routine-anti-age-repulpant-endro-cosmetiques-8158873.webp',
        CDN_HV + 'duo-visage-routine-anti-age-repulpant-endro-cosmetiques-5560805.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5779870.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-4570658.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-3974719.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-9072852.webp',
        CDN_HV + 'routine-visage-anti-age-jour-nuit-endro-cosmetiques-7656766.webp',
      ],
      'creme-nuit|serum-liftant': [
        CDN_HV + 'duo-visage-routine-anti-age-liftant-endro-cosmetiques-4355331.webp',
        CDN_HV + 'duo-visage-routine-anti-age-liftant-endro-cosmetiques-8294935.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-6030759.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5801558.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-6716006.webp',
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-8512926.webp',
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-7002466.webp',
      ],
      'serum-liftant|serum-repulpant': [
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-9554722.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5779870.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5522909.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-4570658.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-1063622.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5801558.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-6110313.webp',
      ],
      'creme-jour|creme-nuit': [
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-2775391.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-8204886.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-3974719.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-9072852.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-6716006.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-6030759.webp',
      ],
      'contour-yeux|creme-jour|serum-repulpant': [
        CDN_HV + 'routine-complete-anti-age-repulpant-endro-cosmetiques-4611921.webp',
        CDN_HV + 'routine-complete-anti-age-repulpant-endro-cosmetiques-5204662.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5779870.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5522909.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-3974719.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-8204886.webp',
        CDN_HV + 'routine-anti-taches-brunes-endro-cosmetiques-coffret-4209211.webp',
      ],
      'contour-yeux|creme-nuit|serum-liftant': [
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-4727433.webp',
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-5616940.webp',
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-6307914.webp',
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-8512926.webp',
        CDN_HV + 'routine-complete-anti-age-liftant-endro-cosmetiques-7002466.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5801558.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-6030759.webp',
      ],
      'contour-yeux|creme-jour|creme-nuit|serum-liftant|serum-repulpant': [
        CDN_HV + 'routine-visage-anti-age-jour-nuit-endro-cosmetiques-2338967.webp',
        CDN_HV + 'routine-visage-anti-age-jour-nuit-endro-cosmetiques-1723968.webp',
        CDN_HV + 'duo-serums-anti-age-endro-cosmetiques-5522909.webp',
        CDN_HV + 'duo-cremes-anti-age-endro-cosmetiques-6716006.webp',
        CDN_HV + 'routine-anti-taches-brunes-endro-cosmetiques-coffret-4209211.webp',
        CDN_HV + 'routine-visage-anti-age-jour-nuit-endro-cosmetiques-7656766.webp',
      ],
    };

    /* ── Un seul produit sélectionné → image du produit seul (reste de la galerie = routine complète) ── */
    var FULL_GALLERY_HV = GALLERIES_HV['contour-yeux|creme-jour|creme-nuit|serum-liftant|serum-repulpant'];
    var SOLO_IMAGES_HV = {
      'serum-repulpant': CDN_HV + 'serum-repulpant-endro-cosmetiques-9290899.webp',
      'creme-jour':      CDN_HV + 'creme-de-jour-anti-age-endro-cosmetiques-3101518.webp',
      'contour-yeux':    CDN_HV + 'soin-contour-yeux-levres-endro-cosmetiques-contour-des-yeux-5430908.webp',
      'serum-liftant':   CDN_HV + 'serum-liftant-collagene-endro-cosmetiques-3355944.webp',
      'creme-nuit':      CDN_HV + 'creme-de-nuit-anti-age-collagene-endro-cosmetiques-7708954.webp',
    };
    var SOLO_GALLERIES_HV = {};
    Object.keys(SOLO_IMAGES_HV).forEach(function (slug) {
      SOLO_GALLERIES_HV[slug] = [SOLO_IMAGES_HV[slug]].concat(FULL_GALLERY_HV.slice(1));
    });

    /* ── Galerie — */
    var track = hero.querySelector('[data-gallery-track]');
    var fades = Array.prototype.slice.call(hero.querySelectorAll('[data-gallery-fade]'));
    var thumbs = Array.prototype.slice.call(hero.querySelectorAll('[data-gallery-thumb]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-gallery-dot]'));
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.endro-aa-slide img')) : [];
    var thumbImgs = thumbs.map(function (t) { return t.querySelector('img'); });
    var active = 0;

    /* Variante sans slider (endro-aa-hero-v5, image statique unique) : la meme
       photo de couverture que la galerie suit la selection, sans miniatures ni
       piste de scroll. Repli sur l'image d'origine des qu'aucun pack ne matche. */
    var heroPhoto = hero.querySelector('[data-hero-photo]');
    var heroPhotoSrcOrigine = heroPhoto ? heroPhoto.getAttribute('src') : null;
    var heroPhotoSrcsetOrigine = heroPhoto ? heroPhoto.getAttribute('srcset') : null;
    function resetHeroPhoto() {
      if (!heroPhoto || !heroPhotoSrcOrigine) return;
      heroPhoto.setAttribute('src', heroPhotoSrcOrigine);
      if (heroPhotoSrcsetOrigine) heroPhoto.setAttribute('srcset', heroPhotoSrcsetOrigine);
      else heroPhoto.removeAttribute('srcset');
    }

    function setActive(i) {
      active = i;
      fades.forEach(function (f, k) { f.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }

    function updateGallery(urls) {
      if (!urls || !urls.length) return;
      setActive(0);
      if (track) track.scrollTo({ left: 0, behavior: 'auto' });
      fades.forEach(function (f, k) { if (urls[k]) f.setAttribute('src', urls[k] + '?width=1920'); });
      slides.forEach(function (img, k) { if (urls[k]) img.setAttribute('src', urls[k] + '?width=1920'); });
      thumbImgs.forEach(function (img, k) { if (img && urls[k]) img.setAttribute('src', urls[k] + '?width=128'); });
      if (heroPhoto) { heroPhoto.removeAttribute('srcset'); heroPhoto.setAttribute('src', urls[0] + '?width=1200'); }
    }

    if (track) {
      track.addEventListener('scroll', function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== active) setActive(idx);
      }, { passive: true });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { setActive(parseInt(t.getAttribute('data-gallery-thumb'), 10)); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        var i = parseInt(d.getAttribute('data-gallery-dot'), 10);
        if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      });
    });

    /* ── Compose + count + prix + CTA — */
    var rows = Array.prototype.slice.call(hero.querySelectorAll('[data-product]'));

    /* ── Sélection par défaut à l'atterrissage (miroir de DEFAULT_SELECTION dans HeroProduct.tsx) ── */
    var DEFAULT_SLUGS_HV = ['serum-repulpant', 'creme-jour', 'contour-yeux'];
    rows.forEach(function (row) {
      var isDefaultOn = DEFAULT_SLUGS_HV.indexOf(row.getAttribute('data-slug')) !== -1;
      row.classList.toggle('is-on', isDefaultOn);
      row.classList.toggle('is-off', !isDefaultOn);
      row.setAttribute('aria-pressed', isDefaultOn ? 'true' : 'false');
    });

    var total = rows.length;
    var elPrice = hero.querySelector('[data-final-price]');
    var elOld = hero.querySelector('[data-old-price]');
    var elBadge = hero.querySelector('[data-discount-badge]');
    var elNote = hero.querySelector('[data-price-note]');
    var elCta = hero.querySelector('[data-cta]');
    var elCountSel = hero.querySelector('[data-selected-count]');
    var elRatingCount = hero.querySelector('[data-rating-count]');
    var elStickerVal = hero.querySelector('[data-sticker-val]');
    var elBreakdown = hero.querySelector('[data-breakdown]');
    var elTitle = hero.querySelector('[data-hv-title]');
    var titleDefault = elTitle ? elTitle.getAttribute('data-hv-title-default') || elTitle.textContent : '';
    var selAllBtn = hero.querySelector('[data-select-all]');
    var selAllDef = selAllBtn ? selAllBtn.querySelector('.endro-aa-hv-sa-default') : null;
    var selAllDone = selAllBtn ? selAllBtn.querySelector('.endro-aa-hv-sa-done') : null;
    var T = {
      ctaFull: hero.getAttribute('data-cta-full'),
      ctaPartial: hero.getAttribute('data-cta-partial'),
      ctaEmpty: hero.getAttribute('data-cta-empty'),
      savePartial: hero.getAttribute('data-save-partial'),
      saveEmpty: hero.getAttribute('data-save-empty'),
    };

    var prevPackKey = null;

    /**
     * Cherche la façon la MOINS CHERE de couvrir la selection avec les packs et
     * les solos qui existent deja sur la boutique.
     *
     * Pourquoi : le configurateur laisse 26 façons de cocher au moins deux soins,
     * mais il n'existe des packs que pour 7 d'entre elles, et aucun a 4 soins.
     * Les 19 autres retombaient au plein tarif, sans remise ni prix barre. Un
     * visiteur qui ajoutait un 4e soin voyait son total monter de 27,88 € pour un
     * produit affiche 24,90 €.
     *
     * La decomposition repare ça sans creer aucun produit chez le marchand : on
     * met au panier « Routine Repulpant + Serum Liftant » au lieu de quatre
     * articles separes. 5 elements au plus, donc la recherche exhaustive est
     * instantanee ; le memo evite juste de recalculer les memes sous-ensembles.
     */
    function decomposerHv(slugs, prixUnit) {
      var memo = {};

      function meilleur(restants) {
        if (!restants.length) return { prix: 0, lignes: [] };
        var cle = restants.join('|');
        if (memo[cle]) return memo[cle];

        // repli : chaque soin a l'unite
        var res = {
          prix: restants.reduce(function (s, g) { return s + (prixUnit[g] || 0); }, 0),
          lignes: restants.map(function (g) {
            return { type: 'solo', slug: g, variantId: SOLO_VARIANTS_HV[g], prix: prixUnit[g] || 0 };
          }),
        };

        for (var i = 0; i < PACKS_HV.length; i++) {
          var p = PACKS_HV[i];
          var membres = p.key.split('|');
          if (membres.length > restants.length) continue;
          var inclus = true;
          for (var m = 0; m < membres.length; m++) {
            if (restants.indexOf(membres[m]) === -1) { inclus = false; break; }
          }
          if (!inclus) continue;
          var reste = restants.filter(function (g) { return membres.indexOf(g) === -1; });
          var sous = meilleur(reste);
          if (p.price + sous.prix < res.prix - 0.001) {
            res = {
              prix: p.price + sous.prix,
              lignes: [{ type: 'pack', pack: p, variantId: p.variantId, prix: p.price }].concat(sous.lignes),
            };
          }
        }
        memo[cle] = res;
        return res;
      }

      return meilleur(slugs.slice().sort());
    }

    function slugsActifs(lignesOn) {
      return lignesOn.map(function (r) { return r.getAttribute('data-slug') || ''; }).filter(Boolean);
    }

    function prixUnitaires(lignesOn) {
      var m = {};
      lignesOn.forEach(function (r) {
        m[r.getAttribute('data-slug')] = parseFloat(r.getAttribute('data-price')) || 0;
      });
      return m;
    }

    function recomputeHv() {
      var on = rows.filter(function (r) { return r.classList.contains('is-on'); });
      var count = on.length;
      var isFull = count === total && total > 0;

      /* — Détection pack — */
      var slugKey = on.map(function (r) { return r.getAttribute('data-slug') || ''; }).filter(Boolean).sort().join('|');
      var pack = null;
      for (var i = 0; i < PACKS_HV.length; i++) {
        if (PACKS_HV[i].key === slugKey) { pack = PACKS_HV[i]; break; }
      }

      if (elCountSel) elCountSel.textContent = count;

      /* — Titre H1 réactif (miroir de displayTitle dans HeroProduct.tsx) — */
      if (elTitle) elTitle.textContent = isFull ? titleDefault : (pack ? pack.name : titleDefault);

      if (selAllDef && selAllDone) {
        selAllDef.hidden = isFull;
        selAllDone.hidden = !isFull;
      }

      var finalP, oldP, discount, savings;
      var lignesAffichage = null; // non-null => grouper le detail par pack reconnu, sinon repli produit par produit
      if (pack) {
        finalP  = pack.price;
        oldP    = pack.compareAt;
        discount = pack.discount;
        savings  = oldP - finalP;
        lignesAffichage = [{ type: 'pack', pack: pack }];
        if (elRatingCount) elRatingCount.textContent = pack.reviews + ' avis';
        if (elStickerVal)  elStickerVal.textContent  = '−' + discount + ' %';
        if (pack.key !== prevPackKey && GALLERIES_HV[pack.key]) {
          updateGallery(GALLERIES_HV[pack.key]);
        }
        prevPackKey = pack.key;
        hero.setAttribute('data-product-url', pack.url);
      } else {
        var plein = on.reduce(function (s, r) { return s + (parseFloat(r.getAttribute('data-price')) || 0); }, 0);
        finalP   = plein;
        oldP     = 0;
        discount = 0;
        savings  = 0;
        if (decompose && count > 1) {
          var dec = decomposerHv(slugsActifs(on), prixUnitaires(on));
          if (dec.prix < plein - 0.001) {
            finalP   = dec.prix;
            oldP     = plein;
            savings  = plein - dec.prix;
            discount = Math.round((savings / plein) * 100);
            lignesAffichage = dec.lignes;
          }
        }
        if (SOLO_GALLERIES_HV[slugKey] && slugKey !== prevPackKey) {
          updateGallery(SOLO_GALLERIES_HV[slugKey]);
        } else if (!SOLO_GALLERIES_HV[slugKey] && prevPackKey !== null) {
          resetHeroPhoto();
          prevPackKey = null;
        }
        if (SOLO_GALLERIES_HV[slugKey]) prevPackKey = slugKey;
      }

      var aRemise = oldP > 0 && discount > 0;
      if (elPrice) elPrice.textContent = count > 0 ? fmtEuro(finalP) : '';
      if (elOld)   { elOld.hidden = !aRemise; if (aRemise) elOld.textContent = fmtEuro(oldP); }
      if (elBadge) {
        elBadge.hidden = !aRemise;
        if (aRemise) elBadge.textContent = '−' + discount + ' %';
      }

      if (elNote) {
        if (aRemise) {
          elNote.classList.add('is-full');
          elNote.textContent = pack
            ? 'Vous économisez ' + fmtEuro(savings) + ' avec ' + pack.name
            : 'Vous économisez ' + fmtEuro(savings) + ' sur cette sélection';
        } else if (count === 0) {
          elNote.classList.remove('is-full');
          elNote.textContent = T.saveEmpty || 'Sélectionnez au moins un produit';
        } else {
          elNote.classList.remove('is-full');
          elNote.textContent = T.savePartial || 'Combinez nos soins pour découvrir nos packs';
        }
      }

      /* Détail de prix : remplace le pack.name ("avec Routine Anti-Âge Repulpant")
         par un calcul ligne à ligne. Le nom du pack ne dit rien au visiteur sur
         un choix qu'il a lui-même personnalisé ; l'addition, si. */
      if (elBreakdown) {
        while (elBreakdown.firstChild) elBreakdown.removeChild(elBreakdown.firstChild);

        function bdRow(nom, val, cls, ancien) {
          var row = document.createElement('div');
          row.className = 'endro-aa-bd-row' + (cls ? ' ' + cls : '');
          var n = document.createElement('span');
          n.className = 'endro-aa-bd-name';
          n.textContent = nom;
          var v = document.createElement('span');
          v.className = 'endro-aa-bd-val';
          if (ancien) {
            var old = document.createElement('span');
            old.className = 'endro-aa-bd-val-old';
            old.textContent = ancien;
            v.appendChild(old);
          }
          v.appendChild(document.createTextNode(val));
          row.appendChild(n);
          row.appendChild(v);
          return row;
        }
        function bdSep() {
          var s = document.createElement('div');
          s.className = 'endro-aa-bd-sep';
          return s;
        }

        if (count === 0) {
          var pEmpty = document.createElement('p');
          pEmpty.className = 'endro-aa-bd-empty';
          pEmpty.textContent = T.saveEmpty || 'Sélectionnez au moins un produit';
          elBreakdown.appendChild(pEmpty);
        } else {
          var label = document.createElement('p');
          label.className = 'endro-aa-bd-label';
          label.textContent = 'Votre sélection · ' + count + (count > 1 ? ' soins' : ' soin');
          elBreakdown.appendChild(label);

          if (lignesAffichage) {
            var nomParSlug = {};
            on.forEach(function (r) { nomParSlug[r.getAttribute('data-slug')] = r.getAttribute('aria-label') || ''; });
            lignesAffichage.forEach(function (ligne) {
              if (ligne.type === 'pack') {
                elBreakdown.appendChild(bdRow(ligne.pack.name + ' (−' + ligne.pack.discount + ' %)', fmtEuro(ligne.pack.price), null, fmtEuro(ligne.pack.compareAt)));
              } else {
                elBreakdown.appendChild(bdRow(nomParSlug[ligne.slug] || '', fmtEuro(ligne.prix)));
              }
            });
          } else {
            on.forEach(function (r) {
              var nom = r.getAttribute('aria-label') || '';
              var prix = parseFloat(r.getAttribute('data-price')) || 0;
              elBreakdown.appendChild(bdRow(nom, fmtEuro(prix)));
            });
          }

          elBreakdown.appendChild(bdSep());
          elBreakdown.appendChild(bdRow('Total', fmtEuro(finalP), 'endro-aa-bd-total'));

          if (!aRemise) {
            var nudge = document.createElement('p');
            nudge.className = 'endro-aa-bd-nudge';
            nudge.textContent = 'Ajoutez un soin de plus pour débloquer une remise.';
            elBreakdown.appendChild(nudge);
          }
        }
      }

      if (elCta) {
        elCta.disabled = count === 0;
        elCta.textContent = count === 0
          ? (T.ctaEmpty || 'Choisissez vos produits')
          : isFull && T.ctaFull
            ? fill(T.ctaFull, { price: fmtEuro(finalP) })
            : fill(T.ctaPartial || 'Ajouter au panier · {price}', { price: fmtEuro(finalP) });
      }
    }

    /* Full-row click (the row IS the button) */
    rows.forEach(function (row) {
      row.addEventListener('click', function () {
        var on = row.classList.toggle('is-on');
        row.classList.toggle('is-off', !on);
        row.setAttribute('aria-pressed', on ? 'true' : 'false');
        recomputeHv();
      });
    });

    /* Select-all tile */
    if (selAllBtn) {
      selAllBtn.addEventListener('click', function () {
        var isFull = rows.every(function (r) { return r.classList.contains('is-on'); });
        if (!isFull) {
          rows.forEach(function (r) {
            r.classList.add('is-on');
            r.classList.remove('is-off');
            r.setAttribute('aria-pressed', 'true');
          });
          recomputeHv();
        }
      });
    }

    if (elCta) {
      elCta.addEventListener('click', function () {
        if (elCta.disabled) return;

        /* Collect active rows and resolve variant IDs */
        var on = rows.filter(function (r) { return r.classList.contains('is-on'); });
        var slugKey = on.map(function (r) { return r.getAttribute('data-slug') || ''; }).filter(Boolean).sort().join('|');

        /* Find matching pack → single variant; otherwise add individual solos */
        var packMatch = null;
        for (var pi = 0; pi < PACKS_HV.length; pi++) {
          if (PACKS_HV[pi].key === slugKey) { packMatch = PACKS_HV[pi]; break; }
        }

        var lineItems;
        if (packMatch && packMatch.variantId) {
          lineItems = [{ id: packMatch.variantId, quantity: 1 }];
        } else if (decompose && on.length > 1) {
          /* Le panier reçoit les memes variantes que celles qui ont servi a
             calculer le prix affiche, sinon on encaisserait autre chose. */
          lineItems = decomposerHv(slugsActifs(on), prixUnitaires(on)).lignes
            .map(function (l) { return l.variantId ? { id: l.variantId, quantity: 1 } : null; })
            .filter(Boolean);
        } else {
          lineItems = on.map(function (r) {
            var slug = r.getAttribute('data-slug');
            var vid  = SOLO_VARIANTS_HV[slug];
            return vid ? { id: vid, quantity: 1 } : null;
          }).filter(Boolean);
        }

        if (!lineItems.length) return;

        var savedText = elCta.textContent;
        elCta.disabled = true;
        elCta.textContent = 'Ajout en cours…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: lineItems }),
        })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function () {
          elCta.textContent = savedText;
          elCta.disabled = false;
          /* Refresh cart count in theme header */
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          /* Open the Impact theme cart drawer */
          var drawer = document.getElementById('cart-drawer');
          if (drawer && typeof drawer.show === 'function') {
            drawer.show();
          } else if (drawer) {
            drawer.setAttribute('open', '');
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(function () {
          elCta.textContent = savedText;
          elCta.disabled = false;
          window.location.href = '/cart';
        });
      });
    }
    recomputeHv();

    /* — Réassurances : slider auto mobile — */
    var rTrack = hero.querySelector('[data-reassure-track]');
    var rDots = hero.querySelectorAll('[data-reassure-dot]');
    if (rTrack && rDots.length) {
      var rIdx = 0;
      var rN = rDots.length;
      function setR(i) {
        rIdx = i;
        rTrack.style.transform = 'translateX(-' + (i * 100) + '%)';
        rDots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      rDots.forEach(function (d, k) { d.addEventListener('click', function () { setR(k); }); });
      setInterval(function () { setR((rIdx + 1) % rN); }, 2800);
    }
  }

  // ─── Intro Schema : toggle Matin/Soir + carrousel ────────────────────
  function replayCswap(scope) {
    scope.querySelectorAll('.endro-aa-cswap').forEach(function (el) {
      el.style.animation = 'none';
      // force reflow
      void el.offsetWidth;
      el.style.animation = '';
    });
  }

  function initRoutineCarousel(routine) {
    if (routine.__carBound) {
      // ré-évalue juste le dot actif (réaffiché)
    }
    var scroll = routine.querySelector('[data-intro-scroll]');
    var dots = routine.querySelectorAll('[data-intro-dot]');
    var steps = routine.querySelectorAll('.endro-aa-intro-scroll .endro-aa-step');
    if (!scroll || !dots.length) return;

    function setDot(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    if (!routine.__carBound) {
      routine.__carBound = true;
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () {
          var el = steps[k];
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio > 0.55) {
              var idx = parseInt(en.target.getAttribute('data-step-index'), 10);
              if (!isNaN(idx)) setDot(idx);
            }
          });
        }, { threshold: [0.55, 0.75], root: scroll });
        steps.forEach(function (s) { io.observe(s); });
      }
    }
    scroll.scrollLeft = 0;
    setDot(0);
  }

  function initIntro(root) {
    (root || document).querySelectorAll('[data-intro]').forEach(function (sec) {
      if (sec.__introBound) return;
      sec.__introBound = true;
      var segs = sec.querySelectorAll('[data-moment]');
      var routines = sec.querySelectorAll('[data-routine]');
      var hintEl = sec.querySelector('[data-intro-hint]');

      function setMoment(m) {
        sec.classList.toggle('is-soir', m === 'soir');
        if (hintEl) {
          hintEl.textContent = m === 'soir'
            ? (sec.getAttribute('data-hint-soir') || '')
            : (sec.getAttribute('data-hint-matin') || '');
        }
        segs.forEach(function (b) {
          var on = b.getAttribute('data-moment') === m;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        routines.forEach(function (r) {
          var on = r.getAttribute('data-routine') === m;
          r.hidden = !on;
          if (on) { replayCswap(r); initRoutineCarousel(r); }
        });
      }

      segs.forEach(function (b) {
        b.addEventListener('click', function () { setMoment(b.getAttribute('data-moment')); });
      });

      // init routine visible au chargement
      routines.forEach(function (r) { if (!r.hidden) initRoutineCarousel(r); });
    });
  }

  // ─── Testé & approuvé : slideshow mobile auto ────────────────────────
  function initTea(root) {
    (root || document).querySelectorAll('[data-tea]').forEach(function (box) {
      if (box.__teaBound) return;
      box.__teaBound = true;
      var track = box.querySelector('[data-tea-track]');
      if (!track) return;
      var slides = track.children.length;
      if (slides < 2) return;
      var i = 0, paused = false;
      function go() {
        track.style.transform = 'translateX(-' + (i * 100) + '%)';
      }
      box.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      box.addEventListener('touchend', function () { paused = false; }, { passive: true });
      setInterval(function () {
        if (paused) return;
        i = (i + 1) % slides;
        go();
      }, 2500);
    });
  }

  // ─── Catalogue : tabs filtre + fade-up staggered ─────────────────────
  function initCatalogue(root) {
    (root || document).querySelectorAll('[data-catalogue]').forEach(function (sec) {
      if (sec.__catBound) return;
      sec.__catBound = true;
      var tabs = sec.querySelectorAll('[data-cat-tab]');
      var grid = sec.querySelector('[data-cat-grid]');
      if (!grid) return;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.endro-aa-cat-card'));

      function apply(f) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-cat-tab') === f;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var vis = 0;
        cards.forEach(function (c) {
          var show = f === 'all' || c.getAttribute('data-ptype') === f;
          c.hidden = !show;
          if (show) {
            c.style.animation = 'none';
            void c.offsetWidth;
            c.style.animationDelay = (vis * 45) + 'ms';
            c.style.animation = '';
            vis += 1;
          }
        });
      }

      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var f = t.getAttribute('data-cat-tab');
          if (t.classList.contains('is-active')) return;
          apply(f);
        });
      });
    });
  }

  // ─── FAQ : accordion single-open ─────────────────────────────────────
  function initFaq(root) {
    (root || document).querySelectorAll('[data-faq]').forEach(function (sec) {
      if (sec.__faqBound) return;
      sec.__faqBound = true;
      var itemsEl = Array.prototype.slice.call(sec.querySelectorAll('[data-faq-item]'));
      itemsEl.forEach(function (item) {
        var btn = item.querySelector('[data-faq-toggle]');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          itemsEl.forEach(function (o) {
            o.classList.remove('is-open');
            var b = o.querySelector('[data-faq-toggle]');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  // ─── Final CTA : parallaxe background ────────────────────────────────
  function initFinalCta(root) {
    (root || document).querySelectorAll('[data-final-cta]').forEach(function (sec) {
      if (sec.__fctaBound) return;
      sec.__fctaBound = true;
      var img = sec.querySelector('[data-fcta-bg]');
      if (!img) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      var raf = null;
      function update() {
        var rect = sec.getBoundingClientRect();
        var vh = window.innerHeight;
        if (rect.bottom < -100 || rect.top > vh + 100) return;
        var center = rect.top + rect.height / 2;
        var offset = (center - vh / 2) / vh;
        img.style.transform = 'translateY(' + (offset * -130) + 'px)';
      }
      function onScroll() {
        if (raf) return;
        raf = requestAnimationFrame(function () { update(); raf = null; });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  }

  // ─── Réassurance bar : auto-scroll mobile (≤699px) ───────────────────
  function initRb(root) {
    (root || document).querySelectorAll('[data-rb]').forEach(function (sec) {
      if (sec.__rbBound) return;
      sec.__rbBound = true;
      var list = sec.querySelector('[data-rb-list]');
      if (!list) return;
      var mql = window.matchMedia('(max-width: 699px)');
      var id = null, paused = false;
      function advance() {
        var w = list.clientWidth;
        var max = list.scrollWidth - w;
        var next = list.scrollLeft + w;
        list.scrollTo({ left: next > max - 4 ? 0 : next, behavior: 'smooth' });
      }
      function start() { if (id == null) id = setInterval(function () { if (!paused) advance(); }, 3000); }
      function stop() { if (id != null) { clearInterval(id); id = null; } }
      list.addEventListener('touchstart', function () { paused = true; }, { passive: true });
      list.addEventListener('touchend', function () { paused = false; }, { passive: true });
      function sync() { if (mql.matches) start(); else stop(); }
      if (mql.addEventListener) mql.addEventListener('change', sync);
      sync();
    });
  }

  // ─── Naturellement : reveal scroll-driven clip-path ──────────────────
  function initNatu(root) {
    (root || document).querySelectorAll('[data-natu]').forEach(function (sec) {
      if (sec.__natuBound) return;
      sec.__natuBound = true;
      var sticky = sec.querySelector('[data-natu-sticky]');
      if (!sticky) return;
      var clipTargets = sec.querySelectorAll('.endro-aa-natu-clipper, .endro-aa-natu-inside');
      var imgs = sec.querySelectorAll('.endro-aa-natu-clipper img');
      var contents = sec.querySelectorAll('.endro-aa-natu-content');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function easeIn(t) { return t * t; }
      function update() {
        if (reduced) {
          clipTargets.forEach(function (el) { el.style.clipPath = 'inset(0)'; });
          imgs.forEach(function (i) { i.style.transform = 'none'; });
          contents.forEach(function (c) { c.style.opacity = '1'; });
          return;
        }
        var rect = sec.getBoundingClientRect();
        var stickyH = sticky.getBoundingClientRect().height;
        var range = rect.height - stickyH;
        if (range <= 0) return;
        var p = Math.max(0, Math.min(1, -rect.top / range));
        var pE = easeIn(p);
        var t = 37 * (1 - pE), r = 37 * (1 - pE), b = 41 * (1 - pE), l = 37 * (1 - pE);
        var clip = 'inset(' + t + '% ' + r + '% ' + b + '% ' + l + '%)';
        clipTargets.forEach(function (e2) { e2.style.clipPath = clip; });
        var tx = -10 * (1 - pE), ty = -1.5 * (1 - pE), sc = 1 + 0.4 * (1 - pE);
        imgs.forEach(function (i) { i.style.transform = 'translate(' + tx + '%, ' + ty + '%) scale(' + sc + ')'; });
        var opacity = p < 0.25 ? p / 0.25 : 1;
        contents.forEach(function (c) { c.style.opacity = String(opacity); });
      }
      var raf = null;
      function onScroll() {
        if (raf) return;
        raf = requestAnimationFrame(function () { update(); raf = null; });
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      update();
    });
  }

  /* ── Filtre flottant natif du theme (facet-floating-filter) ──────────────
     Sur une page collection classique, la grille est en bas de page : le
     filtre fixe reste visible tout du long, sans que ça se voie. Sur cette
     variante, plusieurs sections educatives suivent la grille — le filtre
     restait donc fixe pendant des ecrans entiers de contenu qui n'a rien a
     voir avec un tri de produits. On le masque des que la grille sort
     entierement du viewport, on le remontre si on y revient. */
  function initFacetFloatingFilter() {
    var filtre = document.querySelector('facet-floating-filter, .facets__floating-filter');
    var grille = document.querySelector('[id$="__main"]');
    if (!filtre || !grille || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) filtre.style.removeProperty('display');
        else filtre.style.setProperty('display', 'none', 'important');
      });
    });
    io.observe(grille);
  }

  onReady(function () {
    initRoutinesCta();
    initReveal();
    initScrollTargets();
    initHero();
    initHeroHv();
    initIntro();
    initTea();
    initCatalogue();
    initFaq();
    initFinalCta();
    initRb();
    initNatu();
    initEndroReponse();
    initEec();
    initFacetFloatingFilter();
  });

  // Theme Editor : ré-init quand une section est rechargée
  document.addEventListener('shopify:section:load', function (e) {
    initReveal();
    initRoutinesCta(e.target);
    initScrollTargets(e.target);
    initHero(e.target);
    initHeroHv(e.target);
    initIntro(e.target);
    initTea(e.target);
    initCatalogue(e.target);
    initFaq(e.target);
    initFinalCta(e.target);
    initRb(e.target);
    initNatu(e.target);
    initEndroReponse(e.target);
    initEec(e.target);
  });

  // ─── EndroEnChiffres : count-up on scroll ─────────────────────────────
  function initEec(root) {
    var section = (root || document).querySelector('[data-endro-eec]');
    if (!section || section.__eecBound) return;
    section.__eecBound = true;
    var cells = section.querySelectorAll('[data-eec-val]');
    if (!cells.length) return;
    var ran = false;
    function runCountUps() {
      if (ran) return;
      ran = true;
      cells.forEach(function (cell) {
        var isStatic = cell.getAttribute('data-eec-static') === 'true';
        var to  = parseFloat(cell.getAttribute('data-eec-val')) || 0;
        var sfx = cell.getAttribute('data-eec-suffix') || '';
        var numEl = cell.querySelector('[data-eec-num]');
        if (!numEl) return;
        if (isStatic) { numEl.textContent = to.toLocaleString('fr-FR') + sfx; return; }
        var duration = 1400;
        var start = null;
        var raf = 0;
        function easeOut(p) { return p === 1 ? 1 : 1 - Math.pow(2, -10 * p); }
        function tick(ts) {
          if (!start) start = ts;
          var p = Math.min((ts - start) / duration, 1);
          var val = Math.round(easeOut(p) * to);
          numEl.textContent = val.toLocaleString('fr-FR') + sfx;
          if (p < 1) raf = requestAnimationFrame(tick);
        }
        raf = requestAnimationFrame(tick);
      });
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { runCountUps(); io.disconnect(); }
      });
    }, { threshold: 0.2 });
    io.observe(section);
  }

  // ─── EndroReponse : scroll-driven dual panel ─────────────────────────
  function initEndroReponse(root) {
    var outer = (root || document).querySelector('[data-endro-reponse]');
    if (!outer || outer.__erBound) return;
    outer.__erBound = true;

    var sticky    = outer.querySelector('[data-er-sticky]');
    var inner     = outer.querySelector('[data-er-inner]');
    var eyebrow   = outer.querySelector('[data-er-eyebrow]');
    var titleEl   = outer.querySelector('[data-er-title]');
    var progress  = outer.querySelector('[data-er-progress]');
    var imgCol    = outer.querySelector('[data-er-img-col]');
    var imgColImg = imgCol ? imgCol.querySelector('img') : null;
    var imgMobile = outer.querySelector('[data-er-img-mobile]');
    var imgMobImg = imgMobile ? imgMobile.querySelector('img') : null;
    var dots      = outer.querySelectorAll('[data-er-dot]');

    // Parse panel config
    var cfgEl = outer.querySelector('[data-er-config]');
    var panels = [];
    try { panels = JSON.parse(cfgEl.textContent).panels; } catch (e) {}

    var activePanel = 0;
    var raf = 0;

    function applyColors(p) {
      var numColor = p.numberColor || p.accent || '#C8483A';
      var lblColor = p.textColor || '#1A1A1A';
      outer.querySelectorAll('[data-er-num-color]').forEach(function (el) {
        el.style.color = numColor;
      });
      outer.querySelectorAll('[data-er-lbl-color]').forEach(function (el) {
        el.style.color = lblColor;
      });
      if (progress) progress.style.background = p.accent || numColor;
    }

    function setPanel(idx) {
      var p = panels[idx] || {};

      // Fade out
      if (inner) inner.classList.add('is-out');
      if (imgColImg) imgColImg.classList.add('is-out');
      if (imgMobImg) imgMobImg.classList.add('is-out');

      setTimeout(function () {
        // Update text
        if (eyebrow) eyebrow.textContent = p.eyebrow || '';
        if (titleEl) titleEl.textContent = p.title || '';
        titleEl && (titleEl.style.color = p.textColor || (idx === 1 ? '#142E1F' : '#1A1A1A'));

        // Show/hide items per panel
        outer.querySelectorAll('[data-er-item]').forEach(function (li) {
          var key = li.getAttribute('data-er-item');
          li.hidden = key.indexOf(idx + '-') !== 0;
        });

        // Update images
        if (imgColImg) {
          imgColImg.src = imgColImg.getAttribute('data-er-img-src-' + idx) || '';
          imgColImg.classList.remove('is-out');
        }
        if (imgMobImg) {
          imgMobImg.src = imgColImg ? (imgColImg.getAttribute('data-er-img-src-' + idx) || '') : '';
          imgMobImg.classList.remove('is-out');
        }

        // Colors (num ≠ lbl)
        applyColors(p);

        // Progress bar
        if (progress) progress.style.width = idx === 0 ? '50%' : '100%';

        // Dots
        dots.forEach(function (d, k) {
          d.style.width = k === idx ? '24px' : '8px';
          d.style.background = k === idx ? (p.accent || '#142E1F') : 'rgba(0,0,0,.15)';
        });

        // Fade in
        if (inner) inner.classList.remove('is-out');

        activePanel = idx;
      }, 180);
    }

    // Init state
    if (panels[0]) {
      applyColors(panels[0]);
      if (progress) progress.style.width = '50%';
      dots.forEach(function (d, k) {
        d.style.width = k === 0 ? '24px' : '8px';
        d.style.background = k === 0 ? (panels[0].accent || '#C8483A') : 'rgba(0,0,0,.15)';
      });
    }

    var prevPanel = 0;
    function onScroll() {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var rect = outer.getBoundingClientRect();
        var scrollable = outer.offsetHeight - window.innerHeight;
        if (scrollable <= 0) return;
        var prog = Math.max(0, Math.min(1, -rect.top / scrollable));
        var next = prog < 0.5 ? 0 : 1;
        if (next !== prevPanel) {
          prevPanel = next;
          setPanel(next);
        }
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    // Cleanup on Theme Editor section:unload
    outer.addEventListener('shopify:section:unload', function () {
      window.removeEventListener('scroll', onScroll);
    }, { once: true });
  }

  // ─── Tous les boutons data-variant-id → drawer ────────────────────────
  // Fallback variant IDs par handle produit : les blocks catalogue/routines de
  // la page live n'ont pas de variant_id renseigné (déploiement non-destructif,
  // le template n'est pas écrasé). On résout donc le variant via le handle
  // présent dans data-url, pour que « Ajouter au panier » ouvre le drawer.
  var HANDLE_VARIANTS = {
    'soin-contour-yeux-levres': 52047845097819,
    'creme-visage-anti-age': 52016277881179,
    'serum-anti-age-collagene': 52047857058139,
    'serum-anti-age': 52047734014299,
    'creme-de-nuit-regenerante-au-collagene': 52056385356123,
    'creme-corps-raffermissante': 51002303578459,
    'duo-creme-anti-age-jour-et-nuit': 52097045102939,
    'duo-serums-anti-age': 52097106149723,
    'duo-collagene': 52093177889115,
    'duo-visage-routine-anti-age-repulpant': 52093103931739,
    'routine-visage-anti-age': 52096623083867,
    'routine-visage-anti-age-lifting-et-fermete': 52096862323035,
    'routine-anti-taches-brunes-contour-yeux-anti-taches-creme-anti-age': 52097001161051,
    'routine-visage-anti-age-complete-peaux-matures': 52097000112475
  };
  function resolveVariantId(btn) {
    var vid = btn.getAttribute('data-variant-id');
    if (vid) return vid;
    var url = btn.getAttribute('data-url') || '';
    var m = url.match(/\/products\/([^/?#]+)/);
    if (m && HANDLE_VARIANTS[m[1]]) return String(HANDLE_VARIANTS[m[1]]);
    return '';
  }
  function initRoutinesCta(root) {
    (root || document).querySelectorAll('button[data-variant-id]').forEach(function (btn) {
      if (btn.__routinesCtaBound) return;
      btn.__routinesCtaBound = true;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (btn.disabled) return;
        var vid = resolveVariantId(btn);
        if (!vid) { window.location.href = btn.getAttribute('data-url') || '/cart'; return; }
        var savedText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Ajout en cours…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }),
        })
        .then(function (res) { if (!res.ok) throw new Error('HTTP ' + res.status); return res.json(); })
        .then(function () {
          btn.textContent = savedText;
          btn.disabled = false;
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          var drawer = document.getElementById('cart-drawer');
          if (drawer && typeof drawer.show === 'function') { drawer.show(); }
          else if (drawer) { drawer.setAttribute('open', ''); }
          else { window.location.href = '/cart'; }
        })
        .catch(function () {
          btn.textContent = savedText;
          btn.disabled = false;
          window.location.href = btn.getAttribute('data-url') || '/cart';
        });
      });
    });
  }
  initRoutinesCta();

})();
